import { render, staticRenderFns } from "./Cage.vue?vue&type=template&id=4493b4cc&scoped=true&"
import script from "./Cage.vue?vue&type=script&lang=js&"
export * from "./Cage.vue?vue&type=script&lang=js&"
import style0 from "./Cage.vue?vue&type=style&index=0&id=4493b4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493b4cc",
  null
  
)

export default component.exports